import React, { useEffect, useState } from "react";
import { Input } from "@nextui-org/react";
import { IoSearchCircleOutline } from "react-icons/io5";
import CourseCardsContainer from "../components/CourseCardsContainer";
import { BaseUrl } from "../api";
import { courseType } from "../@types/course";

const Courses = () => {
  const [courses, setCourses] = useState<courseType[]>([]);
  const [searchParam, setSearchParam] = useState("");

  useEffect(() => {
    fetch(`${BaseUrl}/courses/?q=${searchParam}`)
      .then((response) => response.json())
      .then((data) => setCourses(data.courses));
  }, [searchParam]);

  return (
    <div className="flex items-center justify-center flex-col gap-16">
      <div className="max-w-[500px] w-full mt-10">
        <Input
          label="Search"
          isClearable
          radius="lg"
          value={searchParam}
          onChange={(e) => setSearchParam(e.target.value)}
          classNames={{
            label: "text-black/50 dark:text-white/90",
            input: [
              "bg-transparent",
              "text-black/90 dark:text-white/90",
              "placeholder:text-default-700/50 dark:placeholder:text-white/60",
            ],
            innerWrapper: "bg-transparent",
            inputWrapper: [
              "shadow-xl",
              "bg-default-200/50",
              "dark:bg-default/60",
              "backdrop-blur-xl",
              "backdrop-saturate-200",
              "hover:bg-default-200/70",
              "dark:hover:bg-default/70",
              "group-data-[focused=true]:bg-default-200/50",
              "dark:group-data-[focused=true]:bg-default/60",
              "!cursor-text",
              "max-w-[500px] w-full",
            ],
          }}
          placeholder="Search by course name or code or instructor..."
          startContent={
            <IoSearchCircleOutline className="text-black/50 mb-0.5 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0" />
          }
        />
      </div>
      <div>
        <CourseCardsContainer courses={courses} />
      </div>
    </div>
  );
};

export default Courses;
